import { IProduct } from '../../../IProduct';
import { P00039DataRxTxIndex } from '../../P00039Sync';
import { Pool } from '../../../../../../apis/pool.api';

export function P00030InstallationReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.TAir_Controle,
    'taCResetUsine',
    1,
    null,
    productClass,
  );
}
